import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuditCompletionInfo } from '../models/Audits/audit-completion-info';
import { environment } from 'src/environments/environment';
import { AuditSummaryResultRequest } from '../models/Audits/AuditResults/audit-summary-result-request';
import { Audit } from '../models/Audits/audit';
import { AuditResultDetail } from '../models/Audits/AuditResults/audit-result-detail';
import { AuditSummaryResult } from '../models/Audits/AuditResults/audit-summary-result';
import { AuditSummaryFollowupRequest } from '../models/Audits/AuditResults/audit-summary-followup-request';
import { ResultFiltersReturn } from '../models/Audits/AuditResults/result-filters-return';
import { Observable, map } from 'rxjs';
import { PagedAuditResultList } from '../models/Audits/AuditResults/paged-audit-result-list';

export type AuditSummaryStreamEvent =
  | { type: 'status', message: string }
  | { type: 'delta', text: string }
  | { type: 'complete', result: AuditSummaryResult }
  | { type: 'error', result: AuditSummaryResult };

@Injectable({
  providedIn: 'root'
})
export class AuditResultsService {

  constructor(private httpClient: HttpClient) {

  }
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    observe: "response" as "response",
    responseType: "json" as const,
    withCredentials: true
  };

  getAuditResultFilters(): Observable<ResultFiltersReturn>{
     return this.httpClient.get(`${environment.apiUrl}auditresults/getresultfilters`, this.httpOptions).pipe(
      map((res:any) => {
        return new ResultFiltersReturn(res.body!)        
      })
    );
  }
  getAuditResultList(request:AuditSummaryResultRequest): Observable<Audit[]> {
    return this.httpClient.post<Audit[]>(`${environment.apiUrl}auditresults/auditresultlist`,request, this.httpOptions).pipe(
      map((res:any) => {
        if(res.body!=null){
          var returnList:Audit[] = [];
          res.body.forEach((e:Audit)=>{
            returnList.push(new Audit(e));
          })
          return returnList;
        }
        return [];
      })
    );
  }
  getPagedAuditResultList(request:AuditSummaryResultRequest): Observable<PagedAuditResultList> {
    return this.httpClient.post<PagedAuditResultList>(`${environment.apiUrl}auditresults/auditresultlistpaged`, request, this.httpOptions).pipe(
      map((res:any) => {
        return new PagedAuditResultList(res.body || {});
      })
    );
  }
    getAuditResultDetail(request:number):Observable<AuditResultDetail>{
    return this.httpClient.post<AuditResultDetail>(`${environment.apiUrl}auditresults/auditresult`,request, this.httpOptions).pipe(
      map((res:any) => {
        return new AuditResultDetail(res.body!)        
      })
    );
  }
  generateSummary(audits: any):Observable<AuditSummaryResult>{
    return this.httpClient.post<AuditSummaryResult>(`${environment.apiUrl}auditresults/generatesummary`,audits, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;        
      })
    );
  }
  generateSummaryStream(audits: any): Observable<AuditSummaryStreamEvent> {
    return new Observable<AuditSummaryStreamEvent>((observer) => {
      const abortController = new AbortController();

      fetch(`${environment.apiUrl}auditresults/generatesummarystream`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(audits),
        signal: abortController.signal
      }).then(async (response) => {
        if (!response.ok || !response.body) {
          throw new Error(`Summary stream failed with status ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (const line of lines) {
            const trimmed = line.trim();
            if (!trimmed) continue;
            observer.next(JSON.parse(trimmed) as AuditSummaryStreamEvent);
          }
        }

        buffer += decoder.decode();
        const finalLine = buffer.trim();
        if (finalLine) {
          observer.next(JSON.parse(finalLine) as AuditSummaryStreamEvent);
        }

        observer.complete();
      }).catch((error) => {
        if (!abortController.signal.aborted) {
          observer.error(error);
        }
      });

      return () => abortController.abort();
    });
  }
  generateQuickSummary(audits: any):Observable<AuditSummaryResult>{
    return this.httpClient.post<AuditSummaryResult>(`${environment.apiUrl}auditresults/generatequicksummary`,audits, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;
      })
    );
  }
  generateFollowUpRequest(request: AuditSummaryFollowupRequest):Observable<AuditSummaryResult>{
    return this.httpClient.post<AuditSummaryResult>(`${environment.apiUrl}auditresults/generatefollowuprequest`,request, this.httpOptions).pipe(
      map((res:any) => {
        return res.body!;        
      })
    );
  }


}
